<script setup lang="ts">
import { AppButton, AppErrorMessages } from '@/components/';

const { visibility, message, list, color, icon, timer, actionLabel, action, clearSnackbar } = useSnackbar();

const runAction = (): void => {
  action.value?.();
  clearSnackbar();
};

const hasList = computed(() => list.value.length > 0);
const hasIcon = computed(() => !!icon.value);
</script>
<template>
  <v-snackbar
    v-model="visibility"
    :close-on-back="false"
    :attach="true"
    :color="color"
    :timeout="timer"
    rounded
    class="global-snackbar"
  >
    <div class="global-snackbar__border d-flex align-center ga-3">
      <div class="global-snackbar__content">
        {{ message }}
        <AppErrorMessages v-if="hasList" display="list" :error="list" class="global-snackbar__list" />
      </div>
      <div v-if="hasIcon" class="global-snackbar__icon">
        <v-icon :icon="icon || undefined" />
      </div>
      <AppButton v-if="actionLabel" type="button" variant="text" @click="runAction">{{ actionLabel }}</AppButton>
    </div>
  </v-snackbar>
</template>

<style lang="scss">
.global-snackbar {
  &__content {
    flex-grow: 1;
  }

  &__content,
  &__list {
    font-weight: 500;
  }

  &__list {
    padding-top: 3px;
    color: inherit;
    opacity: 1;
  }
}
</style>
